// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__30Dlf","half":"Balance_half__1ta-8","full":"Balance_full__2PjF9"};